<template>
  <div class="main-container" :class="colorMode === 'dark' ? 'dark-block' : ''">
    <h2>How Asoko helps data-driven Investors</h2>
    <p>Asoko provides Investors with Africa’s most reliable private market data to support their market sizing, origination and due diligence.Our Pan-African data-set covers business profiles, shareholders, historical deals and future funding requirements.</p>
    <p>Asoko’s data solutions help to speed-up an Investor’s research process so they can focus less on research and more on deal-making.</p>
    <div class="action-wrap">
      <a @click="openSolutions" class="cta-button" :class="colorMode === 'light' ? 'medium-button' : ''">Learn More</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'investor-intelligence-conversion',
  props: {
    colorMode: {
      type: String,
    },
  },
  methods: {
    openSolutions() {
      this.$ga.event({
        eventCategory: 'Click',
        eventAction: 'Conversion',
        eventLabel: 'Investor Intelligence Block',
      })
      this.$gtag.event('Conversion', {
        'event_category': 'Click',
        'event_label': 'Investor Intelligence Block',
      })
      this.$router.push({ name: 'solutions-page' })
    },
  },
}
</script>
